export const API = {
  login: {
    method: "POST",
    url: "/login",
  },
  userProfile: {
    method: "GET",
    url: "/user/profile",
  },
  updateProfile: {
    method: "POST",
    url: "/user/update_profile",
  },
  updatePassword: {
    method: "POST",
    url: "/user/update_password",
  },
  locationsList: {
    method: "GET",
    url: "/location/list",
  },
  departmentsList: {
    method: "GET",
    url: "/department/list",
  },
  addDepartment: {
    method: "POST",
    url: "/department/add",
  },

  editDepartment: (id) => ({
    method: "POST",
    url: `/department/edit/${id}`,
  }),

  departmentDetails: (id) => ({
    method: "GET",
    url: `/department/details/${id}`,
  }),
  ticketList: {
    method: "GET",
    url: "/admin/ticket/list",
  },
  userList: {
    method: "GET",
    url: "/admin/user/list",
  },
  myNotifications: {
    method: "GET",
    url: "/notification/my",
  },
  ticketDetails: (ticketId) => ({
    method: "GET",
    url: `/ticket/details/${ticketId}`,
  }),
  ticketHistory: (ticketId) => ({
    method: "GET",
    url: `/ticket/history/${ticketId}`,
  }),
  ticketUserList: {
    method: "GET",
    url: "/ticket/list",
  },
  forgotPassword: {
    method: "POST",
    url: "/forgot_password",
  },
  usersList: {
    method: "GET",
    url: "/admin/user/list",
  },

  addUser: {
    method: "POST",
    url: "/admin/user/add",
  },

  editUser: (id) => ({
    method: "POST",
    url: `/admin/user/edit/${id}`,
  }),

  userDetails: (id) => ({
    method: "GET",
    url: `/admin/user/details/${id}`,
  }),
  myTickets: {
    method: "GET",
    url: "/ticket/my",
  },
  addLocation: {
    method: "POST",
    url: "/location/add",
  },

  editLocation: (id) => ({
    method: "POST",
    url: `/location/edit/${id}`,
  }),

  locationDetails: (id) => ({
    method: "GET",
    url: `/location/details/${id}`,
  }),

  outletsList: {
    method: "GET",
    url: "/location/list",
  },
  addOutlet: {
    method: "POST",
    url: "/location/add",
  },
  editOutlet: (id) => ({
    method: "POST",
    url: `/location/edit/${id}`,
  }),
  outletDetails: (id) => ({
    method: "GET",
    url: `/location/details/${id}`,
  }),

  slaList: {
    method: "GET",
    url: "/admin/sla-settings/list",
  },
  slaSettingsUpdate: {
    method: "POST",
    url: "/admin/sla-settings/update",
  },
  maintenanceCheckSla: {
    method: "GET",
    url: "/maintenance/check-sla",
  },

  resetPassword: {
    method: "POST",
    url: "/reset_password",
  },
  register: {
    method: "POST",
    url: "/register",
  },
  allExecutives: {
    method: "GET",
    url: "/get_all_executive",
  },
  createTicket: {
    method: "POST",
    url: "/ticket/create",
  },

  assignTicket: (id) => ({
    method: "POST",
    url: `/ticket/assign_ticket/${id}`,
  }),

  addComment: (ticketId) => ({
    method: "POST",
    url: `/comment/add/${ticketId}`,
  }),

  editComment: (commentId) => ({
    method: "POST",
    url: `/comment/edit/${commentId}`,
  }),

  deleteComment: (commentId) => ({
    method: "DELETE",
    url: `/comment/delete/${commentId}`,
  }),
  updateNotification: (id) => ({
    method: "POST",
    url: `/notification/update/${id}`,
  }),

  deleteNotification: (id) => ({
    method: "DELETE",
    url: `/notification/delete/${id}`,
  }),
  assignedTickets: {
    method: "GET",
    url: "/ticket/assigned_list",
  },
  weeklySummary: {
    method: "GET",
    url: "/executive/weekly_summary",
  },
  ticketsTrend: {
    method: "GET",
    url: "/admin/tickets/trend",
  },
  ticketsKpi: {
    method: "GET",
    url: "/admin/tickets/kpi",
  },
  getAllExecutives: {
    method: "GET",
    url: "/get_all_executive",
  },
  updateTicket: (id) => ({
    method: "POST",
    url: `/ticket/update/${id}`,
  }),

  addComment: (ticketId) => ({
    method: "POST",
    url: `/comment/add/${ticketId}`,
  }),
  acceptTicket: (ticketId) => ({
    method: "POST",
    url: `/ticket/accept/${ticketId}`,
  }),

  updateTicketStatus: (ticketId) => ({
    method: "POST",
    url: `/ticket/update_status/${ticketId}`,
  }),

  addComment: (ticketId) => ({
    method: "POST",
    url: `/comment/add/${ticketId}`,
  }),

  editComment: (commentId) => ({
    method: "POST",
    url: `/comment/edit/${commentId}`,
  }),

  deleteDepartment: (departmentId) => ({
    method: "DELETE",
    url: `/department/delete/${departmentId}`,
  }),
  deleteLocation: (locationId) => ({
    method: "DELETE",
    url: `/location/delete/${locationId}`,
  }),
  deleteOutlet: (id) => ({
    method: "DELETE",
    url: `/location/delete/${id}`,
  }),
  deleteUser: (id) => ({
    method: "DELETE",
    url: `/admin/user/delete/${id}`,
  }),
  slaEmailStatus: {
    url: "/admin/sla-settings/email-status",
    method: "GET",
  },

  slaEmailToggle: {
    url: "/admin/sla-settings/email-toggle",
    method: "POST",
  },
};
